import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { HealthcareFacility, IHealthcareFacility, IHealthcareFacilityPayload } from '../HealthcareFacility.ts';
import { HealthcareFacilitiesApi } from '../../../apis/HealthcareFacilitiesApi/HealthcareFacilitiesApi.ts';
import { useIdFromRoute } from '../../../hooks/useIdFromRoute.tsx';

export function usePutHealthcareFacility() {
    const queryClient = useQueryClient();
    const id = useIdFromRoute();

    return useMutation<IHealthcareFacility, AppMedError, IHealthcareFacilityPayload>({
        mutationKey: [QueryKeys.healthcareFacility, id],
        mutationFn: async (variables: IHealthcareFacilityPayload) => {
            await HealthcareFacilitiesApi.putHealthcareFacilitiesById(variables, id);
            return new HealthcareFacility(variables as HealthcareFacility);
        },
        onSuccess: async (data: IHealthcareFacility) => {
            queryClient.setQueryData<IHealthcareFacility>([QueryKeys.healthcareFacility, id], data);

            queryClient.setQueryData<IHealthcareFacility[]>([QueryKeys.healthcareFacilities], (prev) => {
                if (!prev) return [data];

                return prev.map((facility) => (facility.id === data.id ? data : facility));
            });
        },
    });
}
